import { render, staticRenderFns } from "./confirm-account.vue?vue&type=template&id=3077d14b&scoped=true&"
import script from "./confirm-account.vue?vue&type=script&lang=js&"
export * from "./confirm-account.vue?vue&type=script&lang=js&"
import style0 from "./confirm-account.vue?vue&type=style&index=0&id=3077d14b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3077d14b",
  null
  
)

export default component.exports